import { url } from "../Constants.js";
import { showLog } from "../utils/log.js";

async function FETCH_API(api, body, token, signal) {
  showLog("FetchApi Masuk FETCH_API");
  const userServer = JSON.parse(localStorage.getItem("userServer"));
  body["from_origin"] = "*";
  body["userServer"] = userServer;
  showLog("===== START =====");
  showLog(`HITTED URL = ${url + api}`);
  showLog(`BODY       = ${body}`);
  showLog("===== END =====");
  try {
    const data = await fetch(url + api, {
      signal: signal,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": token ? token : "",
        "Cache-Control": "no-cache",
        "Accept-Encoding": "gzip;q=1.0, compress;q=0.5",
      },
      body: JSON.stringify(body),
    })
      .catch((error) => {
        if (error.name == "AbortError") {
          showLog("request was cancelled");
        }
        let res = {};
        res["status"] = "ERROR";
        res["message"] = "Terjadi kesalahan pada system.";
        return res;
      })
      .then((res) => res.json())
      .then((res) => res)
      .then((err) => err);
    showLog(`Fetch Api = ${data}`);
    return data;
  } catch (error) {
    showLog(`Fetch Api = ${error}`);
  }
}

export default FETCH_API;
